<template>
  <PropertyOnboardingStep title="Select the best option that describes your listing" :submit="submit">
    <FormGroup>
      <RadioButton
        v-for="option in propertyTypeOptions"
        :key="option"
        :value="option"
        v-model="form.fields.propertyType"
        name="propertyType"
      >
        {{ option }}
      </RadioButton>
    </FormGroup>
  </PropertyOnboardingStep>
</template>

<script setup lang="ts">
import { required } from '@vuelidate/validators';
import { watch } from 'vue';

import { FormGroup, RadioButton, useForm } from '@tallo/design-system';
import { SavePropertySpecificationsDto, usePropertyStore } from '@tallo/investor/property';
import { PropertyType } from '@tallo/property';

import PropertyOnboardingStep from '../property-onboarding-step.vue';

const propertyTypeOptions = Object.values(PropertyType);
const form = useForm<Pick<SavePropertySpecificationsDto, 'propertyType'>>(
  { propertyType: null },
  { propertyType: { required } },
);
const propertyStore = usePropertyStore();

watch(
  () => propertyStore?.property?.specifications?.propertyType,
  (value) => Object.assign(form.fields, { propertyType: value ?? PropertyType.APARTMENT }),
  { immediate: true },
);

async function submit() {
  return await form.submit((fields) => propertyStore.saveSpecifications(fields));
}
</script>
